import withSidebar from '../../../hoc/withSideBar/withSideBar';
import OrgSubscriptionTabs from './org-subscription-tabs/OrgSubscriptionTabs';

function OrgSubscriptions() {
    return (
        <div className="page-section">
            <div className="page-header-with-badge">
                <span className="page-header">Subscription Plans</span>
            </div>
            <div className="page-content h-100">
                <div className="content-header">
                    <span className="header-title"></span>
                    <div className="header-fields"></div>
                </div>
                <div className="org-sub-content-body">
                    {/* Subscription plans component */}
                    <OrgSubscriptionTabs />
                </div>
            </div>
        </div>
    );
}

export default withSidebar(OrgSubscriptions);
